import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  CancelPromoClaimRateOverrideRequest,
  OverridePromoClaimRateRequest,
  PromoClaimRateDTO,
} from './promo-claim-rate.model';

@Injectable({
  providedIn: 'root',
})
export class PromoClaimRateService {
  constructor(private readonly http: HttpClient) {}

  public get(playerId: number): Observable<PromoClaimRateDTO> {
    return this.http.get<PromoClaimRateDTO>(this.url(playerId));
  }

  public override(playerId: number, request: OverridePromoClaimRateRequest): Observable<void> {
    return this.http.put<void>(`${this.url(playerId)}/override`, request);
  }

  public cancelOverride(playerId: number, request: CancelPromoClaimRateOverrideRequest): Observable<void> {
    return this.http.delete<void>(`${this.url(playerId)}/override`, { body: request });
  }

  private url(playerId: number): string {
    return `/crm/api/back-office/v1/players/${playerId}/promotion-claim-rate`;
  }
}
